// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1KI4-","signatureButtonsRight":"ModalSign_signatureButtonsRight__VyDey"};